import { defaultSlate } from "./slate";
import spacer from "@react-page/plugins-spacer";

const aboutLayoutPlugin = {
  Renderer: ({ children, data }) => <div>{children}</div>,
  id: "aboutLayoutPlugin",
  title: "About Layout plugin",
  description: "About layout plugin",
  version: "aboutLayoutPlugin",
  controls: {
    type: "autoform",
    schema: {
      properties: {
        title: {
          type: "string",
          default: "Title",
        },
      },
    },
  },
  createInitialChildren: () => {
    return [
      [
        {
          plugin: "dividerText",
        },
      ],
      [
        {
          plugin: spacer,
        },
      ],
      [
        {
          plugin: defaultSlate,
        },
        {
          plugin: defaultSlate,
        },
      ],
      [
        {
          plugin: spacer,
        },
      ],
      [
        {
          plugin: "dividerText",
        },
      ],
      [
        {
          plugin: spacer,
        },
      ],
      [
        {
          plugin: defaultSlate,
        },
        {
          plugin: defaultSlate,
        },
      ],
      [
        {
          plugin: spacer,
        },
      ],
      [
        {
          plugin: "ButtonWithLink",
        },
        {
          plugin: "ButtonWithLink",
        },
        {
          plugin: "ButtonWithLink",
        },
        {
          plugin: "ButtonWithLink",
        },
      ],
    ];
  },
};

export default aboutLayoutPlugin;
